<template>

  <v-data-table
    :headers="_headers"
    :items="_items"
    :server-items-length="_total"
    :footer-props="footer"
    :no-data-text="labels.nodata"
    :options.sync="options"
    :loading="loading"
    @click:row="$emit('click', $event)"
  >
    <template v-slot:item.severity="{ item }">
      <responsive-icon :label="$t(`alarms.severity.${item.severity}`)" breakpoints="xs">
        <alarm-severity :alarm="item"></alarm-severity>
      </responsive-icon>

      <span class="ml-2">{{ type(item) }}</span>
    </template>

    <template v-slot:item.status="{ item }">
      <alarm-status :alarm="item" type="chip"></alarm-status>
    </template>

    <template v-slot:item.detectedAt="{ item }">
      {{ item.detectedAt | datetime }}
    </template>

    <template v-slot:item.actions="{ item }">
      <alarm-controls :alarm="item"
                      :issue="false"
                      @map="$router.push({ name: 'city-map', params: { assetId: $event }})"
                      @removed="remove($event)">
      </alarm-controls>
    </template>
  </v-data-table>

</template>

<script>

  import dataTable from '@/observer/helpers/data-table.es6'
  import AlarmControls from '@/observer/alarms/components/alarm-controls'
  import AlarmSeverity from '@/observer/alarms/components/alarm-severity'
  import AlarmStatus from '@/observer/alarms/components/alarm-status'
  import ResponsiveIcon from '@/observer/shared/components/responsive-icon'

  export default {
    name: 'alarms-table',
    mixins: [ dataTable ],

    props: [ 'hidden' ],

    data () {
      return {
        options: {
          sortBy: [ 'actionAt' ]
        },
        headers: [
          { text: this.$t('alarms.type'), value: 'severity' },
          { text: this.$t('alarms.status'), value: 'status' },
          { text: this.$t('alarms.detected-at'), value: 'detectedAt' },
          { text: this.$t('shared.actions'), value: 'actions', sortable: false, align: 'center'},
        ]
      }
    },

    computed: {
      _headers () {
        return this.headers.filter(column => ![].concat(this.hidden).includes(column.value))
      }
    },

    methods: {
      type (item) {
        return item.alarmType === 'disconnected' ? this.$t('alarm.disconnected') : this.$t(`alarm.type.${item.asset.deviceType}.${item.alarmType}`)
      },

      async remove (alarm) {
        await this.$store.dispatch('destroyItem', { model: { name: 'alarms' }, id: alarm.id })
        this._items.splice(this._items.indexOf(alarm), 1)
      }
    },

    components: {
      ResponsiveIcon,
      AlarmStatus,
      AlarmSeverity,
      AlarmControls,
    },
  }
</script>

<style scoped lang="scss">

</style>
